import React, { useState, useEffect } from 'react'
import { Form, Button, Alert } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../components/auth/useAuth'
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export default function ChangePassword() {
    const navigate = useNavigate()
    const { clientauth } = useAuth()
    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (clientauth && !clientauth.mustChangePassword) {
            navigate(clientauth.rol === 'parent' ? '/parent/dashboard' : '/student/dashboard', { replace: true })
        }
    }, [clientauth, navigate])

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError(null)
        setSuccess(null)

        if (newPassword.length < 6) {
            setError('La contraseña debe tener al menos 6 caracteres')
            return
        }
        if (newPassword !== confirmPassword) {
            setError('Las contraseñas no coinciden')
            return
        }

        setLoading(true)
        try {
            const { data, status } = await Axios.put('/api/profile/change-password',
                { password: currentPassword, newPassword },
                { headers: { auth: localStorage.getItem('jwt') } }
            )
            if (status === 200) {
                setSuccess(data.message || 'Contraseña cambiada correctamente')
                if (data.token) {
                    localStorage.setItem('jwt', data.token)
                }
                setTimeout(() => window.location.href = clientauth?.rol === 'parent' ? '/parent/dashboard' : '/student/dashboard', 1500)
            }
        } catch (err) {
            const msg = err.response?.data?.message || 'Error al cambiar la contraseña'
            setError(msg)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className='login-page'>
            <div className='login-card-wrapper'>
                <div className='login-card'>
                    <div className='login-card-header'>
                        <h1 className='fw-bolder mb-0' style={{ color: '#fff', fontSize: '24px', lineHeight: '1.3' }}>
                            Cambiar contraseña
                        </h1>
                        <p className='mb-0 mt-2' style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px' }}>
                            Por seguridad, debes cambiar tu contraseña antes de continuar
                        </p>
                    </div>

                    <div className='login-card-body'>
                        {error && <Alert variant='danger' dismissible onClose={() => setError(null)}>{error}</Alert>}
                        {success && <Alert variant='success'>{success}</Alert>}

                        <Form onSubmit={handleSubmit}>
                            <div className='mb-3'>
                                <label className='d-block mb-1' style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>Contraseña actual</label>
                                <div className='position-relative'>
                                    <span className='login-input-icon'>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                    </span>
                                    <Form.Control
                                        type="password"
                                        placeholder="Contraseña actual"
                                        value={currentPassword}
                                        onChange={(e) => setCurrentPassword(e.target.value)}
                                        className='login-input'
                                        required
                                    />
                                </div>
                            </div>

                            <div className='mb-3'>
                                <label className='d-block mb-1' style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>Nueva contraseña</label>
                                <div className='position-relative'>
                                    <span className='login-input-icon'>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                    </span>
                                    <Form.Control
                                        type="password"
                                        placeholder="Nueva contraseña"
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        className='login-input'
                                        required
                                    />
                                </div>
                            </div>

                            <div className='mb-4'>
                                <label className='d-block mb-1' style={{ fontSize: '13px', fontWeight: 600, color: '#374151' }}>Confirmar nueva contraseña</label>
                                <div className='position-relative'>
                                    <span className='login-input-icon'>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                                            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                                        </svg>
                                    </span>
                                    <Form.Control
                                        type="password"
                                        placeholder="Repetir nueva contraseña"
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        className='login-input'
                                        required
                                    />
                                </div>
                            </div>

                            <Button type="submit" className='w-100 login-submit-btn' disabled={loading}>
                                {loading
                                    ? <span className="spinner-border spinner-border-sm align-middle"></span>
                                    : 'Cambiar contraseña'
                                }
                            </Button>
                        </Form>
                    </div>
                </div>
            </div>
        </div>
    )
}
